var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from "styled-components";
import Icon from './IconBase';
function CalenderFollowUp(props) {
    if (!(props.width || props.height)) {
        props = Object.assign(__assign({}, props), { width: 21 });
    }
    return (React.createElement(Icon, __assign({ "data-icon": 'chart', viewBox: "0 0 21 23" }, props),
        React.createElement("g", { id: "CalenderFollowUp", fill: "none", transform: "translate(1,1)", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" },
            React.createElement("g", { id: "followup" },
                React.createElement("path", { d: "M4.64820144,16.4705882 L2.08,16.4705882 C0.93124772,16.4705882 0,15.5856922 0,14.4941176 L0,3.62352941 C0,2.53195485 0.93124772,1.64705882 2.08,1.64705882 L13.52,1.64705882 C14.6687523,1.64705882 15.6,2.53195485 15.6,3.62352941 L15.6,8.23529412", id: "Path" }),
                React.createElement("line", { x1: "11.2666667", y1: "0", x2: "11.2666667", y2: "3.29411765", id: "Path" }),
                React.createElement("line", { x1: "4.33333333", y1: "0", x2: "4.33333333", y2: "3.29411765", id: "Path" }),
                React.createElement("line", { x1: "0", y1: "6.58823529", x2: "15.6", y2: "6.58823529", id: "Path" })),
            React.createElement("g", { id: "Group-9", transform: "translate(8.461529, 11.711017)" },
                React.createElement("polyline", { id: "Path-3", points: "-8.47154665e-14 6.90556357 0.912155846 4.90747944 2.98066049 5.27727139" }),
                React.createElement("path", { d: "M1.36044181,6.42264739 C2.13053221,7.79351428 3.64815655,8.72609297 5.39443288,8.72609297 C7.91961639,8.72609297 9.96668209,6.77604432 9.96668209,4.37053741 C9.96668209,1.9650305 7.91961639,0.0149818591 5.39443288,0.0149818591 C4.59815011,0.0149818591 3.84941003,0.208889169 3.19740884,0.549839149", id: "Path" })))));
}
export default styled(CalenderFollowUp)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
